export default __webpack_public_path__ + "static/media/Member_ChinTeTsai.ea9d6a6c.jpg";